module.exports = __webpack_public_path__ + "assets/img/loginBg.6c06dbbc.png";